import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-frame',
    templateUrl: './frame.component.html',
    styleUrls: ['./frame.component.css']
})
export class FrameComponent implements OnInit {

    @Input() showBack = true;
    @Input() showNext = false;
    @Input() title = 'TITLE GOES HERE';
    @Output() back = new EventEmitter();
    @Output() next = new EventEmitter();

    constructor() { }

    onBack() {
        this.back.emit();
    }

    onNext() {
        this.next.emit();
    }

    ngOnInit(): void {
    }
}
